//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetchAll, pageExport } from '@/apis/order'
import { get_order_platform } from '@/apis/config'
import moment from 'moment';
export default {
    data() {
        return {
            config: {
                //運動類型
                platform: [],
            },
            searchQuery: {
                orderNo: '',
                platform: "",
                sDate: "",
                eDate: "",
                exp: 0,
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: '資料建立日期', dataIndex: 'created_at', key: 'created_at', width: 200, },
            { title: '單據編號', dataIndex: 'serial_no', key: 'serial_no', width: 150 },
            { title: '訂單編號', dataIndex: 'order_no', key: 'order_no', width: 240 },
            { title: '客戶編號', dataIndex: 'platform_id', key: 'platform_id', width: 150 },
            { title: '通路', dataIndex: 'source', key: 'source', width: 240 },
            { title: '匯入商品選項', dataIndex: 'goods_spec', key: 'goods_spec', width: 240 },
            { title: '匯入商品貨號', dataIndex: 'goods_no', key: 'goods_no', width: 240 },
            { title: '匯入商品名稱', dataIndex: 'goods_name', key: 'goods_name', width: 240 },
            { title: '原始金額', dataIndex: 'origin_price', key: 'origin_price', width: 240 },
            { title: '方案*組數', dataIndex: 'group_num', key: 'group_num', width: 240 },
            { title: '單價', dataIndex: 'goods_price', key: 'goods_price', width: 240 },
            { title: '數量', dataIndex: 'order_num', key: 'order_num', width: 240 },
            { title: '運費', dataIndex: 'delivery_amount', key: 'delivery_amount', width: 240 },

            { title: '賣場優惠券', dataIndex: 'coupon_amount', key: 'coupon_amount', width: 240 },
            { title: '商品總價', dataIndex: 'amount', key: 'amount', width: 240 },
            { title: '收貨人姓名', dataIndex: 'consignee_name', key: 'consignee_name', width: 240 },
            { title: '收貨人電話', dataIndex: 'consignee_mobile', key: 'consignee_mobile', width: 240 },
            { title: '蝦皮專線和包裹查詢碼', dataIndex: 'pack_no', key: 'pack_no', width: 240 },
            { title: '收貨人地址/取貨門市', dataIndex: 'consignee_address', key: 'consignee_address', width: 240 },

            { title: '最後更新時間', dataIndex: 'updated_at', key: 'updated_at', width: 180, },
            // { title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        moment,
        onChangeDate(value) {
            console.log(`output->value`,value)
            if (value.length > 0) {
                this.searchQuery.sDate = value[0].format('YYYY-MM-DD')
                this.searchQuery.eDate = value[1].format('YYYY-MM-DD')
            } else {
                this.searchQuery.sDate = ""; this.searchQuery.eDate = "";
            }

        },
        async onPageConfig() {
            try {
                let res = await get_order_platform({});
                this.config.platform = res.data.records;

            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    page: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.records = res.data.records;
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },


        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.searchQuery.exp = 0;
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            this.searchQuery.exp = 0;
            e.preventDefault();
            this.onPageLoad(true);
        },
        handleToAdd(id) {
            if (id > 0) {
                this.$router.push(`/order/edit/${id}`);
            } else {
                this.$router.push('/order/add');
            }
        },
        handleToExport() {
            this.searchQuery.exp = 1;
            this.onPageExport();
        },
        async onPageExport() {
            try {
                this.loading = true;
                const response = await pageExport({
                    ...this.searchQuery
                });

                // 創建下載鏈接
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `order_${moment().format('MMDDss')}.xlsx`); // 設置文件名
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        }
    }
}
